import { useState, useEffect } from 'react';

/**
 * Hook para aplicar debounce a valores
 *
 * Retrasa la actualización del valor hasta que pase el tiempo especificado
 * sin cambios. Útil para búsquedas en tiempo real.
 *
 * @param {*} value - Valor a aplicar debounce
 * @param {number} delay - Tiempo de espera en milisegundos
 * @returns {*} Valor con debounce aplicado
 */
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;